/**
 * Mutable execution context passed through milestone steps.
 * Callers supply `form` (e.g. SurveyJS Model) and `formValues` (survey.data).
 * Host identity (formId / incidentId / taskId / …) is seeded from FAF.init host options.
 */
export class FormActionFrameworkContext {
    constructor(init) {
        Object.defineProperty(this, "executionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "organizationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "variables", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "logs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "shouldStop", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "startTime", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "milestone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Read-only host identity for this run (seeded at execute from FAF.hostContext). */
        Object.defineProperty(this, "formId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "incidentId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "taskId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orgId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Page URL when the host started FAF (defaults to window.location.href). */
        Object.defineProperty(this, "pageUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** SurveyJS Model or other form host. */
        Object.defineProperty(this, "form", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Current survey / form field values. */
        Object.defineProperty(this, "formValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /** Present during formChange. */
        Object.defineProperty(this, "change", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.form = init?.form ?? null;
        this.formValues = init?.formValues ?? {};
        if (init) {
            const { form: _f, formValues: _v, variables, logs, ...rest } = init;
            Object.assign(this, rest);
            if (variables)
                this.variables = variables;
            if (logs)
                this.logs = logs;
        }
    }
    log(message) {
        this.logs.push(message);
    }
}
